import { i18n } from 'src/i18n';
import importerActions from 'src/modules/shared/importer/importerActions';
import fields from 'src/modules/workflowLaunch/importer/workflowLaunchImporterFields';
import selectors from 'src/modules/workflowLaunch/importer/workflowLaunchImporterSelectors';
import WorkflowLaunchService from 'src/modules/workflowLaunch/workflowLaunchService';

const workflowLaunchImporterActions = importerActions(
  'WORKFLOW_LAUNCH_IMPORTER',
  selectors,
  WorkflowLaunchService.import,
  fields,
  i18n('entities.workflowLaunch.importer.fileName'),
);

export default workflowLaunchImporterActions;
